var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg2GisColor = function Svg2GisColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.003,
    y: 0.064,
    fill: "#29B24A",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2-gis-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.432,
    y: 1.492,
    fill: "#29B24A",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.857,
    height: 12.857,
    x: 3.574,
    y: 3.992,
    fill: "#fff",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2-gis-color_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29B24A",
    d: "M13.983 11.847c-2.88.014-3.345 1.84-3.5 3.383l-.07.683h-.58l-.07-.683c-.156-1.543-.635-3.369-3.416-3.383-.466-1.01-.664-1.826-.664-2.746 0-2.3 1.793-4.453 4.447-4.453s4.418 2.138 4.418 4.468c0 .905-.085 1.721-.565 2.73m-3.882-9.989c-4.375 0-7.96 3.77-7.96 8.385 0 4.631 3.585 8.4 7.96 8.4 4.419 0 7.99-3.769 7.99-8.4 0-4.615-3.571-8.385-7.99-8.385"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2-gis-color_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.432,
    y: 1.492,
    fill: "#fff",
    rx: 2.857
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2-gis-color_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.146 1.85h51.071v16.786H2.146z"
  })))));
};
export default Svg2GisColor;